import React, { useState } from 'react';
import Arrows from './Arrows';
import {
  DOTS_WIDTH,
  DOTS_SPREAD_RATIO,
  HAIRLINE_WIDTH,
} from '../tool/Diagram';
const BADGE_H = 40;
const BADGE_W = 120;
import { maxVPPCO2 } from '../tool/data';

export default ({
  from,
  to,
  width,
  fromIndex,
  radius = 100,
  turn = 50,
  stroke,
  conn,
  yearId,
  scenarioId,
}) => {
  const [hover, setHover] = useState(false);
  const dX = to.x - from.x;
  const dY = to.y - from.y;
  const minD = Math.min(Math.abs(dX), Math.abs(dY));
  const rad = Math.min(minD / 2, radius);
  const turnPoint = turn / 100;

  const drawLine = () => {
    let baseD = '';

    baseD = [`M ${from.x} ${from.y}`, `h ${dX}`].join(' ');

    return baseD;
  };

  const clickHandler = () => {
    console.log(conn);
  };
  if (!stroke) stroke = `url(#grad_${fromIndex})`;

  let sDA = {};
  width = Math.max(conn.rawW, HAIRLINE_WIDTH);
  let shouldBeDotted =
    (conn.dottedOnlyIf0 && Math.abs(conn.data) < 0.01) ||
    (!conn.dottedOnlyIf0 && conn.rawW <= DOTS_WIDTH / 2);

  if (shouldBeDotted) {
    width = DOTS_WIDTH;
    sDA = {
      strokeDasharray: `${DOTS_WIDTH} ${DOTS_SPREAD_RATIO * DOTS_WIDTH}`,
    };
  }

  let showArrow = true;
  let dir = 'l';
  let aX = from.x + dX / 2;
  let aY = from.y;

  if (width < 10) {
    showArrow = false;
  }

  return (
    <>
      <path
        key={`${conn.rel}-path`}
        d={drawLine()}
        className={`arrow ${conn.rel}`}
        strokeWidth={width}
        {...sDA}
        stroke={stroke}
        fillOpacity={0}
        pointerEvents="stroke"
        onClick={clickHandler}
      />
      {showArrow && (
        <Arrows key={`${conn.rel}-arrow`} x={aX} y={aY} w={width} dir={dir} />
      )}
      {conn.showText && (
        <>
          <rect
            x={from.x + dX / 2 - BADGE_W / 2}
            y={from.y + dY / 2 - BADGE_H / 2}
            width={BADGE_W}
            height={BADGE_H}
            rx={BADGE_H / 2}
            fill={'#4AC9D3'}
            stroke={'#fff'}
            strokeWidth={2}
          />
          <text
            x={from.x + dX / 2}
            y={from.y + dY / 2}
            dy={5}
            dx={0}
            fill={'#fff'}
            textAnchor="middle"
            fontSize="14"
            fontWeight="bold"
          >
            {(conn.rawW * maxVPPCO2[scenarioId]).toFixed(2)} Gt CO₂
          </text>
        </>
      )}
    </>
  );
};
